export const WIP = {
  id: 0,
  name: 'wip'
};
export const ANIMATION = {
  id: 1,
  name: 'animation'
};
export const ILLUSTRATION = {
  id: 2,
  name: 'illustration'
};
export const COMICS = {
  id: 3,
  name: 'comics'
};
export const OBJECTS = {
  id: 4,
  name: 'objects'
};



// WEBPACK FOOTER //
// ./src/projects/categories.js